import { render } from "./RegistrationError.vue?vue&type=template&id=a38311fa"
import script from "./RegistrationError.vue?vue&type=script&lang=js"
export * from "./RegistrationError.vue?vue&type=script&lang=js"
script.render = render

export default script